<div 
    #scrollContainer
    class="suggestions-container"
>
    <!-- Display only 3 suggested questions -->
    @for(question of suggestedQuestions.slice(0, 3) || []; track $index){
    <button
        pButton
        type="button"
        class="p-button-outlined"
        [pTooltip]="question"
        tooltipPosition="top"
        showDelay="500"
        hideDelay="100"
        (click)="handleClick(question);"
    >
        {{ question }}
    </button>
    }
</div>